import axios from '@/axios'
import * as types from '../../mutation-types'

export default {
    namespaced: true,

    state: {
        levels: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/salaries/levels').then(({ data }) => {
                commit(types.STORE_LEVELS, data);
                return data;
            })
        },

        fetchSliceLevels({ commit }, { sliceId }) {
            return axios.get(`/salaries/levels/slices/${sliceId}`)
        },

        create({ commit }, { name, sliceId }) {
            return axios.post('/salaries/salaryLevel', { name, sliceId });
        },

        update({ commit }, { id, name, sliceId }) {
            return axios.put(`/salaries/salaryLevel/${id}`, { name, sliceId });
        },
    },

    mutations: {
        [types.STORE_LEVELS](state, levels) {
            state.levels = levels;
        }
    },

    getters: {
        getLevelById: state => id => state.levels.find(c => c.id === id)
    }
}